module.exports = __webpack_public_path__ + "static/brittney-brewer-ballet-jimani.ba05fbb1.webm";


//////////////////
// WEBPACK FOOTER
// ./src/videos/brittney-brewer-ballet-jimani.webm
// module id = 482
// module chunks = 114276838955818